import { render, staticRenderFns } from "./SupervisorSidebar.vue?vue&type=template&id=5c4f1286&scoped=true&"
import script from "./SupervisorSidebar.vue?vue&type=script&lang=js&"
export * from "./SupervisorSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c4f1286",
  null
  
)

export default component.exports